import React from 'react';

export default class FormBuilder extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: true,
            message: "",
            itemTypes: [
                {typeID: 0, typeName: "Text"},
                {typeID: 2, typeName: "Large Text"},
                {typeID: 1, typeName: "Checklist Item"},
                {typeID: 3, typeName: "Date"},
                {typeID: 4, typeName: "Exclusive List"},
                {typeID: 5, typeName: "Non-Exclusive List"},
                {typeID: 8, typeName: "User Extensible List"},
                {typeID: 7, typeName: "Dropdown List"},
                {typeID: 6, typeName: "Policy Acknowledgement"},
                {typeID: 9, typeName: "Digital Signature"}
            ],
            formData: {
                formID: this.props.id,
                formName: "",
                formDescription: "",
                formSections: []
            },
            selectLists: []
        }
    }
    componentDidMount()
    {
        if (this.props.id !== 0)
            this.loadForm();

        this.loadSelectLists();
    }
    loadForm()
    {
        this.setState({loaded: false}, () => {
            this.props.api.send({
                controller: "Form",
                action: "GetForm",
                method: "post",
                body: JSON.stringify({formID: this.props.id}),
                success: (result) => {
                    console.log(result);
                    this.setState({
                        loaded: true,
                        formData: result.form
                    });
                },
                error: (err) => {
                    this.setState({loaded: true});
                }
            })
        });
    }
    formItemUpdated(e)
    {
        let formData = this.state.formData;
        formData[e.target.name] = e.target.value;
        this.setState({formData: formData});
    }
    sectionUpdated(e, section)
    {
        let formData = this.state.formData;
        let idx = formData.formSections.indexOf(section);
        formData.formSections[idx][e.target.name] = e.target.value;
        this.setState({formData: formData});
    }
    sectionCheckUpdate(e, section)
    {
        let formData = this.state.formData;
        let idx = formData.formSections.indexOf(section);
        formData.formSections[idx][e.target.name] = e.target.checked;
        this.setState({formData: formData})
    }
    itemUpdated(e, section, item)
    {
        let formData = this.state.formData;
        let secidx = formData.formSections.indexOf(section);
        let idx = formData.formSections[secidx].formItems.indexOf(item);
        if(e.target.type === "checkbox")
            formData.formSections[secidx].formItems[idx][e.target.name] = e.target.checked;
        else
            formData.formSections[secidx].formItems[idx][e.target.name] = e.target.value;

        this.setState({formData: formData});
    }
    itemTypeUpdated(e, section, item)
    {
        let formData = this.state.formData;
        let secidx = formData.formSections.indexOf(section);
        let idx = formData.formSections[secidx].formItems.indexOf(item);
        formData.formSections[secidx].formItems[idx][e.target.name] = e.target.value;
        if(e.target.value === "7")
            this.loadSelectLists();

        this.setState({formData: formData});
    }
    itemFileUpdated(e, section, item){
        let formData =this.state.formData;
        let secidx = formData.formSections.indexOf(section);
        let idx = formData.formSections[secidx].formItems.indexOf(item);
        if(e.target.files.length === 1){
            var file = e.target.files[0];
            let f = new FormData();
            f.append("File", file);
            f.append("attachmentType", 1);
            this.props.api.send({
                controller: "Form",
                action: "SaveFormItemFile",
                headers: {'Content-Type': 'multipart/form-data'},
                method: "post",
                body: f,
                fileUpload: true,
                success: (result) => {
                    if(result.success === true){
                        var itemPolicyAttachmentID = result.attachmentID;
                        // snap in attachmentID, and set state. 
                        formData.formSections[secidx].formItems[idx].itemFileName = file.name;
                        formData.formSections[secidx].formItems[idx].itemFilePreview = "";
                        formData.formSections[secidx].formItems[idx].itemPolicyAttachmentID = itemPolicyAttachmentID;
                        var reader = new FileReader();
                        reader.onload = (e) => {
                            formData.formSections[secidx].formItems[idx].itemFilePreview = e.target.result;
                            this.setState({formData: formData})
                        }
                        reader.readAsDataURL(file);
                    }
                }
            });
        }else{
            formData.formSections[secidx].formItems[idx].itemFileName = "";
            formData.formSections[secidx].formItems[idx].itemFilePreview = "";
            this.setState({formData: formData})
        }
    }
    itemListItemUpdated(e, section, item, listItem){
        let formData = this.state.formData;
        let secidx = formData.formSections.indexOf(section);
        let idx = formData.formSections[secidx].formItems.indexOf(item);
        let itemIdx = formData.formSections[secidx].formItems[idx].itemList.indexOf(listItem);
        formData.formSections[secidx].formItems[idx].itemList[itemIdx].itemText = e.target.value;
        this.setState({formData: formData});
    }
    addSection()
    {
        let formData = this.state.formData;
        formData.formSections.push({
            name: "",
            description: "",
            randomize: true,
            single: true,
            admin: false,
            formID: this.props.id,
            formItems: []
        });
        this.setState({formData: formData});
    }
    removeSection(section)
    {
        let formData = this.state.formData;
        let idx = formData.formSections.indexOf(section);
        formData.formSections.splice(idx, 1);
        this.setState({formData: formData});
    }
    removeItem(section, item)
    {
        let formData = this.state.formData;
        let secidx = formData.formSections.indexOf(section);
        let idx = formData.formSections[secidx].formItems.indexOf(item);
        formData.formSections[secidx].formItems.splice(idx, 1);
        this.setState({formData: formData});
    }
    removeItemListItem(e, section, item, listItem){
        let formData = this.state.formData;
        let secidx = formData.formSections.indexOf(section);
        let idx = formData.formSections[secidx].formItems.indexOf(item);
        let itemIdx = formData.formSections[secidx].formItems[idx].itemList.indexOf(listItem);
        formData.formSections[secidx].formItems[idx].itemList.splice(itemIdx, 1);
        this.setState({formData: formData});
    }
    addItem(section)
    {
        let formData = this.state.formData;
        let idx = formData.formSections.indexOf(section);
        if (idx !== -1)
        {
            let sec = formData.formSections[idx];
            sec.formItems.push({
                itemText: "",
                itemList: [],
                itemType: 0,
                attachment: 0
            });
        }
        this.setState({formData: formData});
    }
    addItemListItem(e, section, item, isOther)
    {
        let formData = this.state.formData;
        let idx = formData.formSections.indexOf(section);
        if (idx !== -1)
        {
            let sec = formData.formSections[idx];
            let itemIdx = sec.formItems.indexOf(item);
            if(itemIdx !== -1){
                if(isOther){
                    // checkbox
                    if(e.target.checked){
                        item.itemList.push({
                            itemText: "Other",
                            itemType: 2,
                            readOnly: true
                        });
                    }else{
                        item.itemList = item.itemList.filter(i => i.itemText !== "Other" && i.readOnly !== true);
                    }
                }
                else{
                    var insert = item.itemList.filter(i => i.itemText !== "Other" && i.readOnly !== true).length;
                    item.itemList.splice(insert, 0, {itemText: "",itemType: 1,readOnly: false});
                }
            }
        }
        this.setState({formData: formData});
    }

    loadSelectLists(){
        this.props.api.send({
            controller: "List",
            action: "GetMyLists",
            method: "get",
            success: (response) => {
                response.success ?
                    this.setState({loaded: true, selectLists: response.lists}) :
                    this.setState({loaded: true, error: true})
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }

    saveForm()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Form",
            action: "SaveForm",
            method: "post",
            body: JSON.stringify(this.state.formData),
            success: (result) => {
                this.setState({
                    loaded: true,
                    message: result.success ? "Form saved successfully." : result.message
                });
            },
            error: (err) => { this.setState({loaded: true}) }
        });
    }
    render()
    {
        return this.state.loaded ? (
            <div className="lmsdisplayarea">
                <h3>Form Builder</h3>
                <div className="lmscenter">
                    {this.state.message}
                </div>
                <div className="lmsform">
                    <div className="lmsformheading">
                        <label className="lmsformlabel" style={{width: "auto"}}>Title:</label>   
                        <input type="text" name="formName" className="lmsforminput" 
                            style={{width: "85%"}}
                            value={this.state.formData.formName}
                            onChange={e => this.formItemUpdated(e)} />
                    </div>
                    <div className="lmsformbody" style={{color: "#222222"}}>
                        <div className="lmsforminner">
                            <label className="lmsformlabel" style={{width: "auto"}}>Description:</label>
                            <textarea className="lmsforminput" style={{width: "100%", height: "220px"}} 
                                name="formDescription"
                                value={this.state.formData.formDescription} 
                                onChange={e => this.formItemUpdated(e)} />
                            <div className="formSections">
                                {this.state.formData.formSections.map((section, idx) =>
                                    <div className="formSection" key={idx}>
                                        <h4>Form Section</h4>
                                        <div style={{padding: "10px"}}>
                                            {idx !== 0 ? (
                                                <input type="button" className="lmsbutton" value="Move Up" />
                                            ) : null}
                                            {idx !== this.state.formData.formSections.length -1 ? (
                                                <input type="button" className="lmsbutton" value="Move Down" />
                                            ) : null}
                                            <input type="button" className="lmsbutton" value="Remove" onClick={() => this.removeSection(section)} />
                                        </div>
                                        <div className="lmsformitem">
                                            <label className="lmsformlabel" style={{width: "auto"}}>Name:</label>   
                                            <input type="text" name="name" className="lmsforminput"
                                                value={section.name} onChange={e => this.sectionUpdated(e, section)} />
                                        </div>
                                        <div className="lmsformitem">
                                            <label className="lmsformlabel" style={{width: "auto"}}>Description:</label>
                                            <textarea className="lmsforminput" style={{width: "100%", height: "180px"}} 
                                                name="description"
                                                value={section.description} onChange={e => this.sectionUpdated(e, section)} />
                                        </div>
                                        <div className="lmsformitem">
                                            <label className="lmsformlabel" style={{width: "auto"}}>Randomize Items:</label>
                                            <input type="checkbox" name="randomize" checked={section.randomize} 
                                                style={{position: "relative", top: "6px"}}
                                                onChange={e => this.sectionCheckUpdate(e, section)} />
                                        </div>
                                        <div className="lmsformitem">
                                            <label className="lmsformlabel" style={{width: "auto"}}>Single Item per Screen:</label>
                                            <input type="checkbox" name="single" checked={section.single} 
                                                style={{position: "relative", top: "6px"}}
                                                onChange={e => this.sectionCheckUpdate(e, section)} />
                                        </div>
                                        <div className="lmsformitem">
                                            <label className="lmsformlabel" style={{width: "auto"}}>Admin Only?:</label>
                                            <input type="checkbox" name="admin" checked={section.admin} 
                                                style={{position: "relative", top: "6px"}}
                                                onChange={e => this.sectionCheckUpdate(e, section)} />
                                        </div>
                                        <br />
                                        {section.formItems.map((item, itemidx) =>
                                            <div key={itemidx} className="formItem">
                                                <h4>{section.name === "" ? "Form Field" : section.name + " - Form Field"}</h4>
                                                <div style={{padding: "10px"}}>
                                                    {itemidx !== 0 ? (
                                                        <input type="button" className="lmsbutton" value="Move Up" />
                                                    ) : null}
                                                    {itemidx !== section.formItems.length -1 ? (
                                                        <input type="button" className="lmsbutton" value="Move Down" />
                                                    ) : null}
                                                    <input type="button" className="lmsbutton" value="Remove" onClick={() => this.removeItem(section, item)} />
                                                </div>
                                                <div className="lmsformitem">
                                                    <label className="lsmformlabel" style={{width: "auto"}}>Item Type:</label>
                                                    <select className="lmsforminput" name="itemType" style={{marginLeft: "10px", width: "140px"}} value={item.itemType}
                                                        onChange={e => this.itemTypeUpdated(e, section, item)}>
                                                        {this.state.itemTypes.map(t =>
                                                            <option key={t.typeID} value={t.typeID}>{t.typeName}</option>
                                                        )}        
                                                    </select>
                                                </div>
                                                <div className="lmsformitem">
                                                    <label className="lmsformlabel" style={{width: "auto"}}>Item Text:</label>
                                                    <textarea type="text" name="itemText" className="lmsforminput" style={{width: "100%", height: "110px"}}
                                                        value={item.itemText} onChange={e => this.itemUpdated(e, section, item)} />
                                                </div>
                                                {Number(item.itemType) === 4 || Number(item.itemType) === 5 ? (
                                                    <div className="lmsformitem">
                                                        <label className="lmsformlabel" style={{width: "auto"}}>List Items:</label>
                                                        {
                                                            item.itemList.map((listItem, listItemIdx) =>
                                                            <div key={listItemIdx}>
                                                                <input type="text" value={listItem.itemText} readOnly={listItem.readOnly} className="lmsforminput" onChange={e => this.itemListItemUpdated(e, section, item, listItem)} />
                                                                {listItem.itemType === 1 ? (
                                                                <input type="button" className="lmsbutton" value="Remove"  onClick={e => this.removeItemListItem(e, section, item,  listItem)}  />
                                                                ) : null}
                                                            </div>
                                                            )
                                                        }
                                                        <input type="button" className="lmsbutton" value="Add List Item" onClick={e => this.addItemListItem(e, section, item, false)} />
                                                        <label className="lmsformlabel" style={{width: "auto"}}>Add 'Other' Option:</label>
                                                        <input type="checkbox" checked={item.itemList.filter(i => i.itemType === 2).length > 0} onChange={e => this.addItemListItem(e, section, item, true)}/>
                                                        
                                                    </div>
                                                ) : Number(item.itemType) === 6 ? (
                                                    <div>
                                                        <div className="lmsformitem">
                                                            <input type="file" name="itemText" accept=".pdf" onChange={e => this.itemFileUpdated(e, section, item)}></input>
                                                        </div>
                                                        {item.itemFilePreview ? 
                                                        <div className="lmsformitem">
                                                                <embed src={item.itemFilePreview} type="application/pdf" width="100%" height="600px" />
                                                        </div>
                                                        : null}
                                                    </div>
                                                    
                                                ) : Number(item.itemType) === 7 ? (
                                                    <div className="lmsformitem">
                                                        <label className="lsmformlabel" style={{width: "auto"}}>List:</label>
                                                        <select className="lmsforminput" name="itemDropDownListID" style={{marginLeft: "10px", width: "140px"}} value={item.itemDropDownListID}
                                                        onChange={e => this.itemUpdated(e, section, item)}>
                                                            {this.state.selectLists.map(l =>
                                                                <option key={l.listID} value={l.listID}>{l.name}</option>
                                                            )}        
                                                        </select>
                                                    </div>
                                                ) : Number(item.itemType) === 8 ? (
                                                    <div className="lmsformitem">
                                                        <label className="lmsformlabel" style={{width: "auto"}}>List Items:</label>
                                                        {
                                                            item.itemList.map((listItem, listItemIdx) =>
                                                            <div key={listItemIdx}>
                                                                <input type="text" value={listItem.itemText} readOnly={listItem.readOnly} className="lmsforminput" onChange={e => this.itemListItemUpdated(e, section, item, listItem)} />
                                                                <input type="button" className="lmsbutton" value="Remove"  onClick={e => this.removeItemListItem(e, section, item,  listItem)}  />
                                                            </div>
                                                            )
                                                        }
                                                        <input type="button" className="lmsbutton" value="Add List Item" onClick={e => this.addItemListItem(e, section, item, false)} />
                                                    </div>
                                                ) : Number(item.itemType) === 9 ? (
                                                    <div className="lmsformitem">
                                                        
                                                    </div>
                                                ) : (null)
                                                }
                                                <div>
                                                    <label className="lmsformlabel" style={{width: "auto"}}>Add Attachment Option</label>
                                                    <input type="checkbox" 
                                                    style={{position: "relative", top: "6px"}} 
                                                    checked={item.attachment} 
                                                    onChange={e => this.itemUpdated(e, section, item)}
                                                    name="attachment"
                                                    />
                                                </div>
                                            </div>    
                                        )}
                                        <input type="button" className="lmsbutton" value="Add Item"
                                            onClick={() => this.addItem(section)} />
                                    </div>    
                                )}
                            </div>
                            <input type="button" className="lmsbutton" value="Add Section"
                                onClick={() => this.addSection()} />
                        </div>
                    </div>
                </div>
                <div className="lmscenter">
                    <input type="button" className="lmsbutton" value="Save" onClick={() => this.saveForm()} />
                </div>
            </div>
        ) : (
            <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/forms/formbuilder.js